import React, { useState } from "react";
import LuckyDrawListingTableComponent from "./luckyDrawListingTable.component";
import ConfirmationDialogComponent from "components/dialog/confirmation";
import { getLang } from "app/feature/constants";
import { useHistory } from "react-router-dom";
import {
  ROOT,
  VIEW_TRADITIONAL_RAFFLE_CLAIM_LIST,
  VIEW_INSTANT_WIN_CLAIM_LIST,
} from "modules/lucky-draw-v2/config/lucky-draw-v2.route";
import WinnerDialog from "../../dialog/winnerDialog";
import { progressStatus } from "lib/constants/luckyDrawProgress";
import TranditionalRaffleWinnerDialog from "../../dialog/tranditionalRaffleWinnerDialog";
import {
  TYPE_TRADITIONAL_RAFFLE,
  TYPE_INSTANT_WIN,
} from "modules/lucky-draw-v2/constants";
import { useSelector } from "react-redux";
import {canAccess} from "../../../../profile/redux/selector/profile.selector";
import {AccessRights} from "../../../../../lib/constants/accessRights";
export default function LuckyDrawListingTableContainer({
  hasLuckyDrawEditAccessRight,
  isFetching,
  page,
  search,
  rowsPerPage,
  totalRecords,
  handleChangePage,
  handleChangeRowsPerPage,
  language,
  handleStatusChange,
  handleFetchLuckyDrawList,
  paginationOptions,
  lang,
  isError,
  handleLiveDraw,
  handleAddLuckyDraw,
  handleAddInstantWin,
  handleBinding,
  handleDownloadWinner,
  handlePublished,
  handleEnd,
  handleJoinClose,
  data,
  gameType,
}) {
  const history = useHistory();
  const companyId = useSelector((state) => state.profile.companyID);

  const [confirmationDialogModal, setConfirmationDialogModal] = useState(false);
  const [prizeDialogOpen, setPrizeDialogOpen] = useState(false);
  const [selectedLuckyDrawUuid, setSelectedLuckyDrawUuid] = useState(null);
  const [trPrizeDialogOpen, setTrPrizeDialogOpen] = useState(false);

  const canEditTraditionalRaffle = useSelector(
    (state) => canAccess(state, AccessRights.CampaignV2.LUCKY_DRAW_LIST_WRITE_UPDATE_INSTANT_WIN));
  const canEditInstantWin = useSelector(
    (state) => canAccess(state, AccessRights.CampaignV2.LUCKY_DRAW_LIST_WRITE_UPDATE_TRADITIONAL_RAFFLE));
  const canEditTraditionalRaffleStatus = useSelector(
    (state) => canAccess(state, AccessRights.CampaignV2.LUCKY_DRAW_LIST_WRITE_UPDATE_TRADITIONAL_RAFFLE_STATUS));
  const canEditInstantWinStatus = useSelector(
    (state) => canAccess(state, AccessRights.CampaignV2.LUCKY_DRAW_LIST_WRITE_UPDATE_INSTANT_WIN_STATUS));
  const canDeleteTraditionalRaffle = useSelector(
    (state) => canAccess(state, AccessRights.CampaignV2.LUCKY_DRAW_LIST_WRITE_DELETE_TRADITIONAL_RAFFLE));
  const canDeleteInstantWin = useSelector(
    (state) => canAccess(state, AccessRights.CampaignV2.LUCKY_DRAW_LIST_WRITE_DELETE_INSTANT_WIN));

  const handleView = async (uuid) => {
    const ld = data.find((d) => d.uuid === uuid);
    const isInstantWin = Number(ld.type) === 2;
    if ((isInstantWin && canEditInstantWin) || (!isInstantWin && canEditTraditionalRaffle)) {
      if (ld.progress === progressStatus.setBasic) {
        // open period page
        history.push(
          `${ROOT}/${
            Number(ld.type) === 2 ? "instant-win" : "traditional-raffle"
          }/new?lucky_draw=${uuid}&step=${2}`
        );
      } else if (ld.progress === progressStatus.setPeriod) {
        // open prize page
        history.push(
          `${ROOT}/${
            Number(ld.type) === 2 ? "instant-win" : "traditional-raffle"
          }/new?lucky_draw=${uuid}&step=${3}`
        );
      } else if (ld.progress === progressStatus.setPrize) {
        // open participant page
        history.push(
          `${ROOT}/${
            Number(ld.type) === 2 ? "instant-win" : "traditional-raffle"
          }/new?lucky_draw=${uuid}&step=${Number(ld.type) === 2 ? 5 : 4}`
        );
      } else {
        history.push(
          `${ROOT}/${
            Number(ld.type) === 2 ? "instant-win" : "traditional-raffle"
          }/${uuid}?step=${Number(ld.type) === 2 ? 6 : 5}`
        );
      }
    } else {
      history.push(
        `${ROOT}/${
          Number(ld.type) === 2 ? "instant-win" : "traditional-raffle"
        }/${uuid}?step=${Number(ld.type) === 2 ? 6 : 5}`
      );
    }
  };

  async function handleViewParticipants(id) {
    history.push(`${ROOT}/${id}/participants`);
  }

  async function handleViewPrize(uuid) {
    let ld = data.find((d) => d.uuid === uuid);
    history.push(
      `${ROOT}/${
        Number(ld.type) === 2 ? "instant-win" : "traditional-raffle"
      }/${uuid}?step=3`
    );
  }

  async function handleViewWinner(uuid, progress, type) {
    // Always use modal dialog for View Winner
    if (parseInt(type) === TYPE_TRADITIONAL_RAFFLE) {
      setTrPrizeDialogOpen(true);
      setSelectedLuckyDrawUuid(uuid);
    } else if (parseInt(type) === TYPE_INSTANT_WIN) {
      setPrizeDialogOpen(true);
      setSelectedLuckyDrawUuid(uuid);
    }
  }

  async function handleViewClaimList(uuid, type) {
    if (parseInt(type) === TYPE_TRADITIONAL_RAFFLE) {
      history.push(VIEW_TRADITIONAL_RAFFLE_CLAIM_LIST.replace(":uuid", uuid));
    } else if (parseInt(type) === TYPE_INSTANT_WIN) {
      history.push(VIEW_INSTANT_WIN_CLAIM_LIST.replace(":uuid", uuid));
    }
  }

  async function handleLiveProgress() {
    // handleLiveProgress
  }

  return (
    <>
      <LuckyDrawListingTableComponent
        hasLuckyDrawEditAccessRight={hasLuckyDrawEditAccessRight}
        canEditTraditionalRaffle={canEditTraditionalRaffle}
        canEditInstantWin={canEditInstantWin}
        canEditTraditionalRaffleStatus={canEditTraditionalRaffleStatus}
        canEditInstantWinStatus={canEditInstantWinStatus}
        canDeleteTraditionalRaffle={canDeleteTraditionalRaffle}
        canDeleteInstantWin={canDeleteInstantWin}
        data={data}
        isFetching={isFetching}
        page={page}
        search={search}
        rowsPerPage={rowsPerPage}
        totalRecords={totalRecords}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handleView={handleView}
        handleStatusChange={handleStatusChange}
        handleViewParticipants={handleViewParticipants}
        handleViewPrize={handleViewPrize}
        handleViewWinner={handleViewWinner}
        handleViewClaimList={handleViewClaimList}
        handleLiveDraw={handleLiveDraw}
        handleDownloadWinner={handleDownloadWinner}
        language={language}
        handleFetchLuckyDrawList={handleFetchLuckyDrawList}
        isLoadingLuckyDrawError={isError}
        paginationOptions={paginationOptions}
        lang={lang}
        handleAddLuckyDraw={handleAddLuckyDraw}
        handleAddInstantWin={handleAddInstantWin}
        handleBinding={handleBinding}
        handlePublished={handlePublished}
        handleEnd={handleEnd}
        handleJoinClose={handleJoinClose}
        companyId={companyId}
      />
      <WinnerDialog
        isOpen={prizeDialogOpen}
        handleClose={() => setPrizeDialogOpen(false)}
        luckyDrawUuid={selectedLuckyDrawUuid}
        selectedLuckyDraw={
          selectedLuckyDrawUuid
            ? data.find((d) => d.uuid === selectedLuckyDrawUuid)
            : null
        }
      />
      <TranditionalRaffleWinnerDialog
        isOpen={trPrizeDialogOpen}
        handleClose={() => setTrPrizeDialogOpen(false)}
        luckyDrawUuid={selectedLuckyDrawUuid}
        selectedLuckyDraw={
          selectedLuckyDrawUuid
            ? data.find((d) => d.uuid === selectedLuckyDrawUuid)
            : null
        }
      />
      <ConfirmationDialogComponent
        isOpen={confirmationDialogModal}
        handleClose={() => setConfirmationDialogModal(false)}
        handleProceed={handleLiveProgress}
        type={"success"}
        remark={getLang(lang, "paragraph.PUBLISH_LD_REMARK")}
        description={getLang(lang, "paragraph.PLEASE_CONFIRM")}
        title={getLang(lang, "paragraph.PUBLISH_LD_QUESTION")}
      />
    </>
  );
}
